export default __webpack_public_path__ + "static/media/Kaspy-Phone1.b047581f.webp";